import {Injectable} from '@angular/core';
import {Query, QueryEntity} from '@datorama/akita';
import {SessionStore} from './session.store';
import {BehaviorSubject, Observable} from 'rxjs';
import {Profile, Session} from './session.model';
import {map, tap} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class SessionQuery extends Query<Session> {

    constructor(protected store: SessionStore) {
        super(store);
    }

    accessToken$: Observable<string> = this.select('access_token');

    tokenType$: Observable<string> = this.select('token_type');

    profile$: Observable<Profile> = this.select('profile');

    fullName$: Observable<string> = this.select('profile').pipe(map(profile => profile.given_name));

    role$: Observable<string> = this.select('profile').pipe(map(profile => profile.role));

    userId$: Observable<number> = this.select('profile').pipe(map(profile => profile.userId));

    avatar$: Observable<string> = this.select('profile').pipe(
        map(profile => (profile !== undefined) ?
            profile.given_name.split(' ').map((n: string) => n[0]).join('') : '')
    );

    isAuthenticated$: Observable<boolean> = this.select('access_token').pipe(
        map(token => token !== null),
    );

}
